export default {
  NORA: {
    baseUrl: {
      DEV: 'https://d3bp57v33hncyl.cloudfront.net',
      QA: 'https://d1yii8p56p78hz.cloudfront.net',
      PREPROD: 'https://d2ja1t4z0bvzku.cloudfront.net',
      PROD: 'https://d3fwuswwhi7ss1.cloudfront.net'
    },
    apiDomain: {
      DEV: 'https://vans-staging.demostellar.com',
      QA: 'https://vans-qa.demostellar.com',
      PREPROD: 'https://vans-qa.demostellar.com',
      PROD: 'https://family.vans.com'
    },
    cssUrl: '/vanscanvasnora/vanscanvasnora-webapp.style.css',
    jsUrl: '/loyalty-webapp.bundle.js',
    configUrl: '/vanscanvasnora/app-config.json'
  },
  EMEA: {
    baseUrl: {
      DEV: 'https://ds8s3etqpk8ol.cloudfront.net',
      QA: 'https://d27vi88kv3kei4.cloudfront.net',
      PREPROD: 'https://dghi27fisgxty.cloudfront.net',
      PROD: 'https://d3kvd9ktmn6p4t.cloudfront.net'
    },
    apiDomain: {
      DEV: 'https://vansemea-staging.demostellar.com',
      QA: 'https://vansemea-staging.demostellar.com',
      PREPROD: 'https://vansemea-staging.demostellar.com',
      PROD: 'https://vansemea.runstellar.com'
    },
    cssUrl: '/vanscanvasemea/vanscanvasemea-webapp.style.css',
    jsUrl: '/loyalty-webapp.bundle.js',
    configUrl: '/vanscanvasemea/app-config.json'
  }
}
